<template>
  <div class="custom-order">
    <Breadcrumb />

    <!-- 过滤条件 -->
    <!-- 过滤条件 -->
    <!-- 过滤条件 -->
    <!-- 过滤条件 -->
    <!-- 过滤条件 -->
    <el-tabs
      v-if="user.userType == '00'"
      style="margin: 0 0 -26px 0"
      v-model="activeName"
      type="card"
      @tab-click="getData"
    >
      <el-tab-pane label="全部" name="sum"></el-tab-pane>
      <el-tab-pane label="待付货款" name="notpay"></el-tab-pane>
      <el-tab-pane label="已付货款" name="pay"></el-tab-pane>
      <el-tab-pane label="排单中" name="produce"></el-tab-pane>
      <el-tab-pane label="生产中" name="producing"></el-tab-pane>

      <el-tab-pane label="超期订单" name="overdue"></el-tab-pane>
    </el-tabs>
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="115px">
        <el-row v-if="user.userType != '00'" :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="操作账号：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpandUser"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="nickName"
                    size="small"
                    placeholder="操作账号"
                  ></el-input>
                  <el-checkbox @change="handleChangeUser" v-model="isCheckUser"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.operNos"
                    placeholder="请选择姓名"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                    @change="handleChangeOper"
                  >
                    <el-checkbox
                      v-for="(item, index) in userList"
                      :key="index"
                      :label="item.userName"
                      v-show="
                        (isExpandUser || index < 10) &&
                          item.nickName &&
                          item.nickName.indexOf(nickName) > -1
                      "
                    >
                      {{ item.nickName }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="userList.length > 10"
                  @click="isExpandUser = !isExpandUser"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #4934b2;
                    float: left;
                  "
                >
                  {{ isExpandUser ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="user.userType != '00'" :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpand || index < 10) &&
                          item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #4934b2;
                    float: left;
                  "
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="activeName == 'sum'" :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="订单状态：" class="item">
                <el-checkbox
                  @change="handleChangeStatus"
                  v-model="isCheckStatus"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  clearable
                  v-model="form.orderStatus"
                  placeholder="请选择订单状态"
                  class="input"
                  size="small"
                  style="display: inline; margin: 0 0 0 27px"
                >
                  <el-checkbox
                    v-for="(value, key) in dictData['order_status']"
                    :key="value.value"
                    :label="value.value"
                    >{{ value.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="平台渠道：" class="item">
                <el-select
                  v-model="form.platNo"
                  placeholder="请选择平台渠道"
                  class="input"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="(value, index) in dictData['plat_no']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="来源国家：" class="item">
                <el-select
                  v-model="form.amazonSite"
                  placeholder="请选择来源国家"
                  class="input"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="(value, index) in dictData['amazon_site']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="产品类型：" class="item">
                <el-select
                  v-model="form.productType"
                  placeholder="请选择产品类型"
                  class="input"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="(value, index) in dictData['product_type']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="物流方式：" class="item">
                <el-select
                  clearable
                  v-model="form.shippingMethod"
                  placeholder="请选择物流方式"
                  class="input"
                  size="small"
                >
                  <el-option
                    v-for="(value, key) in shipList"
                    :key="value.shippingMethod"
                    :label="value.shippingMethodName"
                    :value="value.shippingMethod"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="匹配类型：" class="item">
                <el-select
                  clearable
                  v-model="form.matchType"
                  placeholder="请选择匹配类型"
                  class="input"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['match_type']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="订单来源：" class="item">
                <el-select
                  clearable
                  v-model="form.orderSource"
                  placeholder="请选择订单来源"
                  class="input"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['order_source']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="创建时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.createTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="支付时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.payTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="发货时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.sendTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                style="position:relative;"
                label="订单编号："
                class="item"
              >
                <el-input
                  class="batch_inputbox input"
                  v-if="!showAppNosTextarea"
                  placeholder="多单号查询请用英文逗号隔开"
                  v-model="form.appNos"
                  size="small"
                  clearable
                />
                <span
                  @click="handleShowAppsNos"
                  v-if="!showAppNosTextarea"
                  class="batch_txt btnIconDown"
                >
                  批量
                </span>
                <div class="textareaBox">
                  <el-input
                    v-if="showAppNosTextarea"
                    type="textarea"
                    :rows="6"
                    placeholder="换行可批量（无需逗号结尾）"
                    v-model="appNos"
                    show-word-limit
                    maxlength="1000"
                    @blur="handleAppNosBlur"
                  >
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="物流单号：" class="item">
                <el-input
                  v-model="form.trackingNumber"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="产品SKU：" class="item">
                <el-input
                  v-model="form.itemSku"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col v-if="user.userType == '00'" :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="商家账号：" class="item">
                <el-select
                  clearable
                  size="small"
                  v-model="form.pOperNo"
                  filterable
                  remote
                  :remote-method="getAccountList"
                >
                  <template v-for="(value, key) in accountList">
                    <el-option
                      :key="value.userName"
                      :label="
                        `${value.userName}${
                          value.nickName ? '(' + value.nickName + ')  ' : ''
                        }`
                      "
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col v-if="user.userType != '00'" :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="成品编号：" class="item">
                <el-input
                  v-model="form.designId"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="标记类型：" class="item">
                <el-select
                  clearable
                  v-model="form.orderRemarkType"
                  placeholder="请选择标注类型"
                  class="input"
                  size="small"
                  multiple
                  filterable
                >
                  <el-option
                    v-for="(value, index) in dictData['remarkType']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="标记颜色：" class="item">
                <el-select
                  clearable
                  v-model="form.orderRemarkColor"
                  placeholder="请选择标记类型"
                  class="input"
                  size="small"
                  multiple
                  filterable
                >
                  <template
                    lable="99"
                    v-for="(value, key) in textColorList"
                    :value="key"
                  >
                    <el-option
                      :key="value.hex"
                      :label="value.name"
                      :value="value.hex"
                    >
                      <div
                        class="background-color-item"
                        :style="{ background: value.hex }"
                        style="position: relative"
                      ></div>
                      <div class="background-color-text">{{ value.name }}</div>
                    </el-option>
                  </template>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col v-if="user.userType == '00'" :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="工厂编号：" class="item">
                <el-select
                  clearable
                  v-model="form.manufacturer"
                  placeholder="请选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(value, index) in dictData['MANUFACTURER']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col v-if="user.userType == '00'" :span="8">
            <div class="grid-content bg-purple">
              <el-form-item
                style="position:relative;"
                label="删除订单编号："
                class="item"
              >
                <el-input
                  class="batch_inputbox input"
                  v-if="!showAppNosTextareaDel"
                  placeholder="多单号查询请用英文逗号隔开"
                  v-model="form.appNoDels"
                  size="small"
                  clearable
                />
                <span
                  @click="handleShowAppsNosDel"
                  v-if="!showAppNosTextareaDel"
                  class="batch_txt btnIconDown"
                >
                  批量
                </span>
                <div class="textareaBox">
                  <el-input
                    v-if="showAppNosTextareaDel"
                    type="textarea"
                    :rows="6"
                    placeholder="换行可批量（无需逗号结尾）"
                    v-model="appNoDels"
                    show-word-limit
                    maxlength="1000"
                    @blur="handleAppNosBlurDel"
                  >
                  </el-input>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="订单时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.orderTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="item right">
              <el-button type="primary" size="small" @click="getData(1)"
                >搜索</el-button
              >
              <el-button type="default" size="small" @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top table-menu">
        <div class="left">
          <el-button
            type="success"
            size="small"
            @click="goReview"
            v-if="
              user.userType == '00' &&
                activeName != 'notpay' &&
                role != '分站管理员'
            "
          >
            批量审核
          </el-button>
          <el-button
            style="margin: 0 0 0 16px;"
            type="success"
            size="small"
            @click="handleQuickOrderBatch"
            v-if="
              user.userType == '00' &&
                activeName != 'notpay' &&
                role != '分站管理员'
            "
          >
            批量加急
          </el-button>
          <el-button
            style="margin: 0 0 0 16px;"
            type="success"
            size="small"
            @click="handleQuickOrderBatchNew"
            v-if="
              user.userType == '00' &&
                activeName != 'notpay' &&
                role != '分站管理员'
            "
          >
            批量加急（新）
          </el-button>
          <el-button
            type="success"
            size="small"
            @click="goPay"
            v-if="showPayButton"
          >
            批量支付货款
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="handleBatchLabel"
            v-if="user.userType !== '00'"
          >
            批量标记
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="syncOrder"
            v-if="user.userType !== '00'"
          >
            同步订单
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="exportOrder"
            v-if="user.userType !== '00'"
          >
            导出订单
          </el-button>
          <el-dropdown
            v-if="user.userType == '01'"
            @command="handleCommand"
            style="margin-left: 12px"
          >
            <el-button size="small" type="primary">
              利润设置<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="exchange">汇率设置</el-dropdown-item>
              <el-dropdown-item command="service">手续费设置</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-row style="display: flex; flex-wrap: wrap; background-color: white">
        <el-col
          :span="12"
          style="
            display: flex;
            padding-left: 20px;
            color: #333333;
            font-size: 14px;
            align-items: center;
          "
        >
          <div v-if="rowSelectNum > 0">已选中{{ rowSelectNum }}条数据</div>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>
      <el-table
        id="myOrder"
        ref="table"
        :data="tableData"
        class="table"
        :default-expand-all="true"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              ref="detailTable"
              class="table"
              border
              :data="[props.row]"
              :show-header="false"
            >
              <el-table-column :width="orderWidth">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.skuList"
                      :key="index"
                      v-if="
                        (index < 3 && !scope.row.expand) || scope.row.expand
                      "
                    >
                      <div class="left">
                        <el-popover placement="right" trigger="hover">
                          <div
                            v-if="
                              scope.row.productType == '01' &&
                                scope.row.orderStatus == '01'
                            "
                            style="text-align: center; padding: 4px 0"
                          >
                            <a
                              style="float: left; font-weight: bold"
                              target="_blank"
                              :href="
                                `${item.ifNewDesign == '01' ? getDesignUrl : '/design/online/tool'}?designId=${item.designId}`
                              "
                              >重新设计</a
                            >
                            <a
                              style="float: right; font-weight: bold"
                              target="_blank"
                              :href="
                                `${item.ifNewDesign == '01' ? getDesignUrl : '/design/online/tool'}?designId=${item.designId}&appSkuId=${item.appSkuId}&pId=${item.pId}`
                              "
                              >替换产品</a
                            >
                            产品编号：{{ item.pId }}
                          </div>
                          <div>
                            <img
                              style="width: 320px; height: 320px"
                              :src="
                                item.picUrl
                                  ? `${item.picUrl}?x-oss-process=image/resize,m_fill,h_500,w_500`
                                  : item.customizedUrl
                                  ? item.customizedUrl
                                  : item.amazonPicUrl
                                  ? item.amazonPicUrl
                                  : noImage
                              "
                            />
                          </div>
                          <div v-if="item.customizedUrl || item.amazonPicUrl">
                            <a
                              style="font-weight: bold"
                              target="_blank"
                              :href="
                                item.customizedUrl
                                  ? item.customizedUrl
                                  : item.amazonPicUrl
                              "
                              >客户图片下载</a
                            >
                          </div>

                          <div slot="reference" style="position: relative">
                            <img
                              class="mini-img"
                              :src="
                                item.picUrl
                                  ? `${item.picUrl}?x-oss-process=image/resize,m_fill,h_500,h_500`
                                  : item.customizedUrl
                                  ? item.customizedUrl
                                  : item.amazonPicUrl
                                  ? item.amazonPicUrl
                                  : noImage
                              "
                            />
                            <div
                              v-if="item.customizedUrl"
                              class="product-tag"
                              style="background: rgb(73, 52, 178)"
                            >
                              定制设计
                            </div>
                            <div class="design_flag">{{ item.ifNewDesign == '01' ? '新' : '旧' }}</div>
                          </div>
                        </el-popover>
                        <div
                          v-if="scope.row.productType == '02'"
                          class="product-type"
                        >
                          {{ scope.row.productType == "01" ? "定制" : "优选" }}
                        </div>
                      </div>
                      <div class="right">
                        <div
                          style="line-height: 15px; margin: 2px 0 0 0"
                          v-if="item.amazonProductName"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="`${item.amazonProductName}`"
                            placement="top-start"
                          >
                            <div
                              class="text-ellipsis"
                              style="display: inline-block; width: 350px"
                              :style="{
                                width: Number(orderWidth) - 139 + 'px',
                              }"
                            >
                              <span> {{ item.amazonProductName }}</span>
                            </div></el-tooltip
                          >
                        </div>
                        <div
                          v-if="item.itemSku"
                          :title="item.itemSku"
                          class="text-ellipsis"
                        >
                          {{ item.itemSku }}
                        </div>
                        <div
                          style="
                            color: #4934b2;
                            cursor: pointer;
                            line-height: 15px;
                            margin: 2px 0 0 0;
                          "
                          @click="handleOpenDetail(item)"
                          v-if="item.proName"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="
                              `${item.proName}${
                                item.designId ? '（' + item.designId + '）' : ''
                              }`
                            "
                            placement="top-start"
                          >
                            <div
                              class="text-ellipsis"
                              style="display: inline-block; width: 350px"
                              :style="{
                                width: Number(orderWidth) - 139 + 'px',
                              }"
                            >
                              <span> {{ item.proName }}</span>
                              <span v-if="item.designId">
                                ({{ item.designId }})</span
                              >
                            </div></el-tooltip
                          >
                        </div>
                        <div
                          :title="item.properVal"
                          class="text-ellipsis"
                          v-if="item.properName"
                        >
                          <span v-if="item.properName && item.properVal">
                            <span
                              v-for="(i, ind) in [0, 1]"
                              :key="'i_' + ind"
                              style="margin-right: 10px"
                            >
                              {{ item.properName.split(":")[i] }}：
                              {{ item.properVal.split(":")[i] }}
                            </span>
                          </span>
                        </div>
                        <div
                          v-else-if="item.color || item.size"
                          class="text-ellipsis"
                        >
                          <span style="margin-right:8px;" v-if="item.color">
                            {{ item.color }}
                          </span>
                          <span v-if="item.size">
                            {{ item.size }}
                          </span>
                        </div>
                        <div>
                          <span>数量：{{ item.num || "-" }}</span>
                          <span
                            v-if="user.userType == '00'"
                            style="margin: 0 0 0 9px"
                            >工厂编号 ：{{ item.proCode }}
                          </span>
                        </div>
                        <div>
                          <span v-if="item.salePrice" style="margin: 0 8px 0 0"
                            >{{ dictMap["currency_mark"][scope.row.currency]
                            }}{{ item.salePrice || "-" }}</span
                          >
                          <span v-if="item.proPrice"
                            >货款：￥{{ item.proPrice || "-" }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      style="line-height: 36px; margin: -6px 0 0 0"
                      v-if="scope.row.skuList.length >= 4"
                    >
                      <span
                        @click="handleExpand(scope.row)"
                        style="
                          color: #4934b2;
                          cursor: pointer;
                          margin: 0 0 0 16px;
                        "
                        >{{ scope.row.expand ? "收起" : "展开" }}</span
                      >
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="160">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    <div>
                      <span class="title"> 产品金额 </span>
                      ：
                      <span v-if="scope.row.saleTotal">
                        {{ dictMap["currency_mark"][scope.row.currency] }}
                        {{ scope.row.saleTotal }}
                      </span>
                      <span v-else>-</span>
                    </div>
                    <div>
                      <span class="title"> 运费 </span>
                      ：
                      <span v-if="scope.row.saleFare !== null">
                        {{ dictMap["currency_mark"][scope.row.currency] }}
                        {{ scope.row.saleFare }}
                      </span>
                      <span v-else>-</span>
                    </div>
                    <div>
                      <span class="title"> 销售促销 </span>
                      ：
                      <span v-if="scope.row.saleDiscount !== null">
                        {{ dictMap["currency_mark"][scope.row.currency] }}
                        {{ scope.row.saleDiscount }}
                      </span>
                      <span v-else>-</span>
                    </div>
                    <div>
                      <span class="title"> 售卖总计 </span>
                      ：
                      <span v-if="scope.row.saleActPay">
                        {{ dictMap["currency_mark"][scope.row.currency] }}
                        {{ scope.row.saleActPay }}
                      </span>
                      <span v-else>-</span>
                      <i
                        class="el-icon-edit-outline"
                        @click="showSale(scope.row)"
                        v-if="user.userType == '01'"
                      ></i>
                    </div>
                    <div style="text-align: center">
                      （产品数:{{ scope.row.skuList.length }} 件数:{{
                        caculateProduct(scope.row.skuList)
                      }}）
                    </div>
                    <div style="text-align:center;min-height: 26px;">
                      <span
                        v-if="scope.row.payMethod"
                        style="color:#4934b2;border:1px solid #4934b2;padding: 0px 8px;margin: 0 0px 0 0;    display: inline-block;border-radius:5px;"
                      >
                        {{ scope.row.payMethod }}
                      </span>

                      <span
                        v-if="
                          scope.row.sOrderExt && scope.row.sOrderExt.pickupWay
                        "
                        style="padding: 0px 8px;    display: inline-block;"
                      >
                        <el-tooltip
                          v-if="scope.row.sOrderExt.pickupWay == '01'"
                          class="item"
                          effect="dark"
                          placement="bottom"
                        >
                          <div slot="content">
                            取件时间：{{ scope.row.sOrderExt.pickupTime
                            }}<br />取件地点：{{
                              scope.row.sOrderExt.pickupAddr
                            }}
                          </div>
                          <div>
                            [快递取件]
                          </div>
                        </el-tooltip>
                        <span v-else>自行寄件</span>
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="160">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    <div>
                      <span class="title"> 产品货款 </span>
                      ： ¥ {{ scope.row.proTotal || "-" }}
                    </div>
                    <div>
                      <span class="title"> 刺绣费用 </span>
                      ： ¥ {{ scope.row.embroideryCost || "-" }}
                    </div>
                    <div>
                      <span class="title"> 运费 </span>
                      ： ¥ {{ scope.row.proFare || "-" }}
                    </div>
                    <div>
                      <span class="title"> 优惠金额 </span>
                      ： ¥ {{ scope.row.proDiscount || "-" }}
                    </div>
                    <div>
                      <span class="title"> 成本总计 </span>
                      ： ¥ {{ scope.row.proActPay || "-" }}
                    </div>
                    <div>
                      <span class="title"> 利润 </span>
                      ： ¥
                      {{
                        scope.row.saleActPay
                          ? scope.row.ext
                            ? (
                                (Number(scope.row.ext.profit.replace("%", "")) *
                                  Number(scope.row.proActPay)) /
                                100
                              ).toFixed(2)
                            : "-"
                          : "-"
                      }}
                    </div>
                    <div>
                      <span class="title"> 利润率 </span>
                      ：
                      {{
                        scope.row.saleActPay
                          ? scope.row.ext
                            ? scope.row.ext.profit
                            : "-"
                          : "-"
                      }}

                      <el-popover
                        v-if="scope.row.ext && scope.row.saleActPay"
                        placement="bottom"
                        trigger="hover"
                      >
                        <LoanTip
                          :loadData="scope.row"
                          @exchange="exchange"
                          @service="service"
                        />
                        <i class="el-icon-info" slot="reference"></i>
                      </el-popover>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" :width="tdWidth">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    <div v-if="scope.row.addr && scope.row.addr.receName">
                      {{ scope.row.addr.receName }}（{{
                        dictMap["amazon_site"][scope.row.addr.state]
                      }}）
                    </div>
                    <div v-else>-</div>

                    <div
                      v-if="
                        scope.row.expreList && scope.row.expreList.length > 0
                      "
                    >
                      <div
                        v-for="(record, index) in scope.row.expreList"
                        :key="index"
                      >
                        <div v-if="record.shippingMethodName">
                          <span v-if="scope.row.expreList.length > 1"
                            >{{ index + 1 }}.</span
                          >
                          {{ record.shippingMethodName }}
                          <a
                            v-if="record.shipList && record.shipList.length > 0"
                            style="cursor: pointer"
                            @click="handleShowDetail(record)"
                            >发货详情</a
                          >
                        </div>
                        <div v-if="record.trackingNumber">
                          【<a
                            style="cursor: pointer"
                            @click="handleShowExpre(record, scope.row)"
                            >{{ record.trackingNumber }}</a
                          >】
                          <i
                            title="复制"
                            class="el-icon-document-copy"
                            style="cursor: pointer"
                            @click="copyText(record.trackingNumber)"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="scope.row.expre">
                      <div
                        v-if="
                          scope.row.expre && scope.row.expre.shippingMethodName
                        "
                      >
                        {{ scope.row.expre.shippingMethodName }}
                      </div>
                      <div
                        v-if="scope.row.expre && scope.row.expre.trackingNumber"
                      >
                        【<a
                          style="cursor: pointer"
                          @click="handleShowExpre(scope.row.expre, scope.row)"
                          >{{ scope.row.expre.trackingNumber }}</a
                        >】
                        <i
                          title="复制"
                          class="el-icon-document-copy"
                          style="cursor: pointer"
                          @click="copyText(scope.row.expre.trackingNumber)"
                        ></i>
                      </div>
                    </div>
                    <div>
                      <div v-if="scope.row.shippingProviderType">
                        <span style="">{{
                          scope.row.shippingProviderType
                        }}</span>
                      </div>
                      <div v-if="scope.row.shippingProvider">
                        <span style="">{{ scope.row.shippingProvider }}</span>
                      </div>
                      <div v-if="scope.row.trackingCode">
                        <span style="">
                          <a
                            style="cursor: pointer"
                            @click="handleShowExpre(scope.row, scope.row)"
                            >{{ scope.row.trackingCode }}</a
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" :width="tdWidth">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    <div
                      v-if="scope.row.platNo == '03'"
                      style="font-weight:bold;color: rgb(73, 52, 178);"
                    >
                      {{
                        scope.row.amazonOrderStatus
                          ? dictMap["lazada_status"][
                              scope.row.amazonOrderStatus
                            ]
                          : "-"
                      }}
                    </div>
                    <div
                      v-if="scope.row.platNo == '05'"
                      style="font-weight:bold;color: rgb(73, 52, 178);"
                    >
                      {{
                        scope.row.amazonOrderStatus
                          ? dictMap["shopee_status"][
                              scope.row.amazonOrderStatus
                            ]
                          : "-"
                      }}
                    </div>
                    <div
                      v-if="scope.row.platNo == '10'"
                      style="font-weight:bold;color: rgb(73, 52, 178);"
                    >
                      {{
                        scope.row.amazonOrderStatus
                          ? dictMap["tiktok_status"][
                              scope.row.amazonOrderStatus
                            ]
                          : "-"
                      }}
                    </div>
                    <div>
                      订单下单时间<br />
                      {{ scope.row.orderTime }}
                    </div>
                    <div>
                      揽收预警时间<br />
                      {{ scope.row.slaTimeStamp }}
                    </div>
                    <div v-if="false">
                      承诺发货时间<br />
                      {{ scope.row.promisedShippingTime }}
                    </div>
                    <div>
                      实际发货时间<br />
                      {{ scope.row.receiveTime }}
                    </div>
                    <div v-if="scope.row.cancelTime">
                      订单取消时间<br />
                      {{ scope.row.cancelTime }}
                    </div>

                    <div
                      v-if="scope.row.amazonOrderStatus != 'canceled'"
                      :style="{ color: scope.row.hintColor }"
                    >
                      {{
                        getHourHint(
                          scope.row.slaTimeStamp,
                          scope.row.receiveTime
                        )
                      }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="150" align="center">
                <template slot-scope="scope">
                  <div class="loan-wrap">
                    <div v-if="user.userType == '00' && scope.row.pOperNo">
                      {{ scope.row.pOperNo }}
                    </div>
                    <div>
                      {{
                        dictMap["order_status"][scope.row.orderStatus] || "-"
                      }}
                      <span v-if="scope.row.orderStatus == '04'"
                        >（{{ getProducingDay(scope.row.payTime) }}天）</span
                      >
                    </div>
                    <div v-if="scope.row.createTime">
                      <div class="title">创建时间</div>
                      <div>{{ scope.row.createTime }}</div>
                    </div>
                    <div v-if="scope.row.payTime">
                      <div class="title">支付时间</div>
                      <div>{{ scope.row.payTime || "-" }}</div>
                    </div>
                    <div v-if="scope.row.auditTime">
                      <div class="title">审核时间</div>
                      <div>{{ scope.row.auditTime || "-" }}</div>
                    </div>
                    <div v-if="scope.row.sendTime">
                      <div class="title">发货时间</div>
                      <div>{{ scope.row.sendTime }}</div>
                    </div>
                    <div v-if="scope.row.orderStatus === '09'">
                      <br />
                      <el-button
                        type="primary"
                        size="small"
                        @click="goRelate(scope.row)"
                        v-if="user.userType !== '00'"
                      >
                        关联产品
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template slot-scope="scope">
                  <div v-if="user.userType !== '00'" class="operate">
                    <!-- 待付款/未付款/已取消才有编辑 -->
                    <span
                      class="link"
                      @click="edit(scope.row)"
                      v-if="['01', '06', '09'].includes(scope.row.orderStatus)"
                    >
                      编辑
                    </span>
                    <!-- <span class="link" @click="remark(scope.row)">
                      备注
                    </span> -->
                    <!-- 已付货款/已取消的不能取消订单 -->
                    <span
                      class="link"
                      @click="cancelOrderFn(scope.row)"
                      v-if="
                        ['01', '02', '03', '09'].includes(scope.row.orderStatus)
                      "
                    >
                      取消订单
                    </span>
                    <!-- 只有取消订单才有恢复订单 -->
                    <span
                      class="link"
                      @click="renewOrder(scope.row)"
                      v-if="
                        scope.row.orderStatus === '06' ||
                          scope.row.orderStatus === '07'
                      "
                    >
                      恢复订单
                    </span>
                    <!-- 除了待编辑其他的都有复制订单 -->
                    <span
                      class="link"
                      @click="copy(scope.row)"
                      v-if="scope.row.orderStatus !== '09'"
                    >
                      复制订单
                    </span>
                    <span
                      class="link"
                      @click="handleShowSendOrderShopee(scope.row)"
                      v-if="
                        scope.row.amazonOrderStatus == 'READY_TO_SHIP' &&
                          scope.row.platNo == '05' &&
                          scope.row.sShopAuth
                      "
                      style="color:red"
                    >
                      制单
                    </span>
                    <span
                      @click="handleShowUploadLabel(scope.row)"
                      class="link"
                      v-if="
                        ['01', '09'].includes(scope.row.orderStatus) &&
                          (scope.row.platNo == '03' || scope.row.platNo == '05')
                      "
                    >
                      {{ scope.row.attachId ? "修改面单" : "上传面单" }}
                    </span>
                    <span
                      class="link"
                      @click="getLabel(scope.row)"
                      v-if="
                        (['01', '09'].includes(scope.row.orderStatus) &&
                          scope.row.platNo == '03' &&
                          scope.row.orderSource == '03') ||
                          (scope.row.amazonOrderStatus != 'READY_TO_SHIP' &&
                            ['01', '09'].includes(scope.row.orderStatus) &&
                            scope.row.sShopAuth &&
                            scope.row.platNo == '05' &&
                            scope.row.orderSource == '03')
                      "
                    >
                      获取面单
                    </span>
                  </div>
                  <div class="operate" v-else>
                    <span
                      class="link"
                      @click="showAudit(scope.row)"
                      v-if="['02'].includes(scope.row.orderStatus)"
                    >
                      审核
                    </span>
                    <span
                      class="link"
                      @click="handleShowSendOrder(scope.row)"
                      v-if="
                        ['04'].includes(scope.row.orderStatus) &&
                          scope.row.productType == '02'
                      "
                    >
                      发货
                    </span>
                    <span
                      @click="handleQuickOrder(scope.row)"
                      class="link"
                      v-if="
                        ['03'].includes(scope.row.orderStatus) &&
                          scope.row.productType == '01'
                      "
                    >
                      加急
                    </span>
                    <el-button
                      @click="handleQuickOrderNew(props.row)"
                      class="link"
                      type="text"
                      size="small"
                      v-if="
                        ['03'].includes(props.row.orderStatus) &&
                        props.row.productType == '01'
                      "
                    >
                      加急（新）
                    </el-button>
                    <span
                      @click="handleRefund(scope.row)"
                      class="link"
                      v-if="
                        (['03', '04'].includes(scope.row.orderStatus) &&
                          scope.row.productType == '01') ||
                          (['04'].includes(scope.row.orderStatus) &&
                            scope.row.productType == '02' &&
                            role != '分站管理员')
                      "
                    >
                      取消
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column
          label="产品信息"
          align="left"
          :width="Number(orderWidth) - 60"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.sOrderExt && scope.row.sOrderExt.note"
              style="height:25px;width:25px;border-radius: 5px;display:inline-block;float:left;margin: 0 8px 0 0;cursor:pointer;"
            >
              <el-tooltip
                effect="dark"
                :content="scope.row.sOrderExt.note"
                placement="top-start"
              >
                <div>
                  <i
                    style="color:#4934b2;font-size:17px;"
                    class="el-icon-s-comment"
                  ></i>
                </div>
              </el-tooltip>
            </div>
            <div
              style="
                text-align: left;
                padding: 0 16px 0 0;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
              "
            >
              <div
                v-if="
                  scope.row.sOrderRemark && scope.row.sOrderRemark.length > 0
                "
                @click="showLabelDialog(scope.row)"
                style="height:25px;width:25px;border-radius: 5px;display:inline-block;float:left;margin: 0 8px 0 0;cursor:pointer;"
              >
                <el-tooltip
                  effect="dark"
                  :content="
                    `${
                      scope.row.sOrderRemark[0].remarkType == '99'
                        ? scope.row.sOrderRemark[0].remarkContent
                        : dictMap['remarkType'][
                            scope.row.sOrderRemark[0].remarkType
                          ]
                    }`
                  "
                  placement="top-start"
                >
                  <div
                    style="width:100%;height:100%;min-width:1px;"
                    :style="{
                      background: scope.row.sOrderRemark[0].remarkColor,
                    }"
                  ></div>
                </el-tooltip>
              </div>
              <div style="display: inline-block;float:left;">
                订单号：<span
                  @click="edit(scope.row)"
                  style="color: #4934b2; cursor: pointer; margin: 0 16px 0 0;display:inline-block;"
                  >{{ scope.row.appNo }}</span
                >
                <span
                  @click="copyText(scope.row.appNo)"
                  style="color: #4934b2; cursor: pointer; margin: 0 16px 0 0"
                  ><el-tooltip
                    effect="dark"
                    :content="`复制`"
                    placement="top-start"
                    ><i class="el-icon-document-copy"></i> </el-tooltip
                ></span>
              </div>

              <div v-if="scope.row.attachId" style="display: inline-block">
                <a
                  target="_blank"
                  :href="scope.row.attachUrl"
                  style="color: #4934b2; cursor: pointer; margin: 0 28px 0 0"
                  >查看面单信息</a
                >
              </div>
              <div style="position: absolute; left: 360px; top: 0">
                承诺发货时间：<span style="color: red; margin: 0 8px 0 0">{{
                  scope.row.latestShipDate
                }}</span
                ><span>
                  <i
                    @click="handleShowSendTime(scope.row)"
                    style="color: #4934b2; cursor: pointer"
                    class="el-icon-edit-outline"
                  ></i
                ></span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="销售总计"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          label="货款总计"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          label="收件人【物流方式】"
          align="center"
          :width="tdWidth"
        ></el-table-column>
        <el-table-column
          label="第三方状态/时间"
          align="center"
          :width="tdWidth"
        ></el-table-column>
        <el-table-column
          label="状态"
          align="center"
          :width="150"
        ></el-table-column>
        <el-table-column
          width="100"
          v-if="false"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div
              style="
                text-align: right;
                padding: 0 16px 0 0;
                position: absolute;
                right: 24px;
                top: 12px;
                min-width: 390px;
              "
            >
              {{ dictMap["plat_no"][scope.row.platNo] || "" }}：{{
                scope.row.shopName
              }}

              <span style="margin: 0 0 0 16px"
                >操作人：{{
                  scope.row.nickName ? scope.row.nickName : scope.row.operNo
                }}</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>

    <ExpreDetail
      @onClose="handleCloseExpre"
      :detail="expreDetail"
      :visible="expreVisible"
    ></ExpreDetail>

    <!-- 编辑订单弹窗 -->
    <EditOrder
      v-if="currentOrder && currentOrder.order"
      :canEdit="orderCanEdit"
      :appId="currentAppId"
      :visible="showEdit"
      :orderDetail="currentOrder"
      @onClose="hideEdit"
      @onUpdate="onUpdateFinish"
    />

    <!-- 同步订单弹窗 -->
    <SyncOrder
      :platNo="``"
      :visible="showSyncOrder"
      @onClose="hideSyncOrder"
      @update="getData"
    />

    <!-- 汇率设置弹窗 -->
    <ExchangeDialog
      :visible="showExchange"
      @onClose="hideExchange"
      @onOk="okEditExchange"
    />

    <!-- 取消订单设置弹窗 -->
    <CancelDialog
      :orderData="currentOrder"
      :visible="showCancel"
      @onClose="hideCancel"
      @onOk="okEditCancel"
    />

    <!-- 手续费设置弹窗 -->
    <ServiceDialog
      :visible="showService"
      @onClose="hideService"
      @onOk="okEditService"
    />
    <!-- 发货时间设置弹窗 -->
    <sendDialog
      :orderData="currentOrder"
      :visible="showSendTime"
      @onClose="hideSendTime"
      @onOk="okEditSendTime"
    />

    <!-- 备注弹窗 -->
    <RemarkDialog :visible="showRemark" @onClose="hideRemark" />

    <!-- 复制弹窗 -->
    <CopyOrder
      v-if="currentOrder.order"
      :visible="showCopy"
      @onClose="hideCopy"
      :orderData="currentOrder"
      @onOk="okCopyOrder"
    />

    <!-- 销售设置弹窗 -->
    <EditSale
      :visible="showEditSale"
      @onClose="hideEditSale"
      :orderData="currentOrder"
      @onOk="okEditSale"
    />

    <!-- 订单审核弹窗 -->
    <AuditOrder
      :visible="showAuditOrder"
      @onClose="hideAuditOrder"
      :orderData="currentOrder"
      @onOk="okAuditOrder"
    />

    <!-- 订单审核弹窗 -->
    <LabelDialog
      :visible="showLabel"
      @onClose="hideLabelDialog"
      :remarkIds="remarkIds"
      :orderRemark="orderRemark"
      @onOk="okLabelDialog"
    />

    <!-- 选择快递弹窗 -->
    <SelectShip
      :orderData="currentOrder"
      :visible="showShip"
      @onClose="hideShip"
    />

    <!-- 发货弹窗 -->
    <SendOrder
      :orderData="currentOrder"
      :visible="showSendOrder"
      @onClose="hideSendOrder"
    />

    <SendOrderShopee
      :orderData="currentOrder"
      :visible="showSendOrderShopee"
      @onClose="hideSendOrderShopee"
    />
    <el-dialog
      title="产品列表"
      :visible.sync="detailVisible"
      width="60%"
      :before-close="handleCloseDetail"
    >
      <el-table :data="productList" class="exchange-table">
        <el-table-column prop="shippingMethodName" label="主题名称">
          <template slot-scope="scope">
            <a style="cursor: pointer" @click="handleOpenProduct(scope.row)">{{
              scope.row.proName
            }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="color" label="颜色"> </el-table-column>
        <el-table-column prop="size" label="尺码"> </el-table-column>
        <el-table-column prop="quantity" label="数量"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleCloseDetail"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="`上传面单`"
      :visible.sync="showUploadLabel"
      width="540px"
      class="remarkDialog"
    >
      <el-form
        :rules="rules"
        :model="importForm"
        ref="importForm"
        label-width="120px"
      >
        <el-form-item prop="file" label="选择文件：">
          <input
            type="file"
            name="file"
            class="webuploader"
            accept=""
            @change="uploadFn"
            ref="inputer"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUploadLabel = false" size="small"
          >返回</el-button
        >
        <el-button type="primary" @click="handleUploadLabel" size="small">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import LoanTip from "./components/LoanTip"
import EditOrder from "./components/EditOrder"
import SyncOrder from "./components/SyncOrder"
import ExchangeDialog from "./components/ExchangeDialog"
import ServiceDialog from "./components/ServiceDialog"
import sendDialog from "./components/SetSendTime"
import RemarkDialog from "./components/RemarkDialog"
import LabelDialog from "./components/LabelDialog"
import EditSale from "./components/EditSale"
import CopyOrder from "./components/CopyOrder"
import AuditOrder from "./components/AuditOrder"
import SendOrder from "./components/SendOrder"
import CancelDialog from "./components/CancelOrder"
import { selectExpreList, getExpreProcess } from "@/api/order/all"
import { mapGetters } from "vuex"
import dayjs from "dayjs"
import {
  orderList,
  getOrderDetail,
  cancelOrder,
  recoveryOrder,
  orderToCopy,
  createShip,
  createBatchShip,
  exportExcel,
  uploadTb,
  getTb,
  downloadDoc,
} from "@/api/order/all"
import { getShipMethod } from "@/api/product/shipMethod"
import SendOrderShopee from "./components/SendOrderShopee"
import { getShopList } from "@/api/system/shopManage"
import noImage from "@/assets/images/no_image.png"
import SelectShip from "./components/SelectShip"
import qs from "qs"
import { downLoadExcel } from "@/utils/zipdownload"
import ExpreDetail from "./components/ExpreDetail"
import { listSubAccount } from "@/api/system/user"
import { listUser } from "@/api/business/merchantManage"

export default {
  name: "order",
  components: {
    Breadcrumb,
    SyncOrder,
    LoanTip,
    ExchangeDialog,
    ServiceDialog,
    sendDialog,
    EditOrder,
    RemarkDialog,
    LabelDialog,
    CopyOrder,
    EditSale,
    AuditOrder,
    SelectShip,
    SendOrder,
    ExpreDetail,
    CancelDialog,
    SendOrderShopee,
  },
  data() {
    return {
      shopList: [],
      shopListClone: [],
      noImage: noImage,
      appNoDels: [],
      form: {
        platNo: "", // 平台渠道
        amazonSite: "", // 来源国家
        productType: "", // 产品类型
        matchType: "", // 匹配类型
        orderSource: "", // 订单来源
        createTime: [], // 创建时间
        payTime: [], // 支付时间
        sendTime: [], // 发货时间
        orderTime:[], // 订单时间
        shopId: [], // 店铺名称
        appNos: "", // 订单编号
        appNoDels: "",
        trackingNumber: "", // 物流单号
        orderStatus: [], // 订单状态
        pOperNo: "", //商家账号
        shippingMethod: "", //物流方式
        itemSku: "",
        pageNum: 1,
        pageSize: 30,
        operNos: [],
        orderRemarkType: [],
        orderRemarkColor: [],
        manufacturer: "",
      },
      remarkIds: "",
      rules: {
        file: [{ required: true, message: "请选择文件", trigger: "change" }],
      },
      importForm: {
        appId: "",
        file: null,
      },
      textColorList: [
        {
          hex: "#171717",
          name: "black",
        },
        {
          hex: "#00FFFF",
          name: "cyan",
        },
        {
          hex: "#a1a1a1",
          name: "grey",
        },
        {
          hex: "#9c6a23",
          name: "brown",
        },
        {
          hex: "#d82424",
          name: "red",
        },
        {
          hex: "#ee6419",
          name: "orange",
        },
        {
          hex: "#50b03c",
          name: "green",
        },
        {
          hex: "#035239",
          name: "darkGreen",
        },
        {
          hex: "#192c7c",
          name: "blue",
        },
        {
          hex: "#3f92db",
          name: "sky",
        },
        {
          hex: "#934b7c",
          name: "purple",
        },
        {
          hex: "#ffde00",
          name: "yellow",
        },
      ],
      appNos: "",
      showAppNosTextarea: false,
      showAppNosTextareaDel: false,
      showUploadLabel: false,
      cancelOrderVisible: false, //取消订单弹框
      modalTitle: "",
      modalText: "",
      statusText: "",
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      multipleSelection: [], // 选中列表数据
      showSyncOrder: false,
      showService: false,
      showExchange: false,
      showCancel: false,
      showEdit: false,
      showRemark: false,
      showLabel: false,
      showShip: false,
      showCopy: false,
      showSendOrder: false,
      showEditSale: false,
      showAuditOrder: false,
      currentOrder: {},
      currentAppId: "",
      orderCanEdit: true,
      roles: [],
      shipList: [],
      isCheckShop: true,
      isCheckStatus: true,
      scrollMenu: null,
      objectHeight: null,
      expreList: [],
      expreDetail: {},
      expreVisible: false,
      isExpand: false,
      shopName: "",
      isExpandUser: false,
      nickName: "",
      isCheckUser: true,
      userList: [],
      activeName: "sum",
      accountList: [],
      detailVisible: false,
      showSendTime: false,
      productList: [],
      orderRemark: {},
      showSendOrderShopee: false,
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
    rowSelectNum() {
      return this.multipleSelection.length
    },
    showPayButton() {
      let permission = JSON.stringify(this.$store.state.permission)
      return permission.indexOf("GetPay") !== -1
    },
    orderWidth() {
      let width = document.body.clientWidth
      let orderWidth = "476"
      if (width > 1500) {
        orderWidth = "476"
      } else {
        orderWidth = "339"
      }
      return orderWidth
    },
    tdWidth() {
      let width = document.body.clientWidth
      let orderWidth = "200"
      if (width > 1400) {
        orderWidth = "189"
      } else {
        orderWidth = "129"
      }
      return orderWidth
    },
    role() {
      return this.$store.state.user.roles[0]
    },
    getDesignUrl() {
      return localStorage.getItem('isNewDesignFlag') === '2' ? '/design/online/designerOther' : '/design/online/designerNew'
    }
  },
  mounted() {
    this.getCache()
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.form.createTime = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    let appNo = this.$route.query.appNo
    if (appNo) {
      this.form.appNos = appNo
      this.form.createTime = []
    }
    let status = this.$route.query.status
    if (status) {
      this.activeName = status
    }

    this.getShops()
    this.getData()
    this.getShip()
    this.getUserList()
    this.getAccountList()
    this.roles = this.user.roles
    // this.dictData["order_status"].map((record) => {
    //   this.form.orderStatus.push(record.value)
    // })
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    async getAccountList(query) {
      let pageSize = 10
      if (!query) {
        query = ""
      } else {
        pageSize = 1000
      }
      let result = await listUser({
        pageNum: 1,
        pageSize: pageSize,
        userType: "01",
        userName: query,
      })
      this.accountList = result.rows
    },
    getHourHint(slaTimeStamp, receiveTime) {
      if (slaTimeStamp) {
        var reDate = /\d{4}-\d{1,2}-\d{1,2} /
        slaTimeStamp = new Date(
          (reDate.test(slaTimeStamp)
            ? slaTimeStamp
            : "2018-1-1 " + slaTimeStamp
          ).replace(/-/g, "/")
        )
      }
      if (slaTimeStamp && !receiveTime) {
        let s2 = new Date()
        var ms = Math.round(
          (slaTimeStamp.getTime() - s2.getTime()) / 1000 / 60 / 60
        )
        if (ms >= 0) {
          return "将在" + ms + "小时后过期"
        } else {
          return "已过期" + -ms + "小时"
        }
      } else if (slaTimeStamp && receiveTime) {
        let s2 = new Date(receiveTime)
        var ms = Math.round(
          (s2.getTime() - slaTimeStamp.getTime()) / 1000 / 60 / 60
        )
        if (ms > 0) {
          return "超期" + ms + "小时发货"
        } else {
          return "正常发货"
        }
      } else {
        return ""
      }
    },
    getHourColor(slaTimeStamp, receiveTime) {
      let hintColor = "red"
      if (slaTimeStamp) {
        var reDate = /\d{4}-\d{1,2}-\d{1,2} /
        slaTimeStamp = new Date(
          (reDate.test(slaTimeStamp)
            ? slaTimeStamp
            : "2018-1-1 " + slaTimeStamp
          ).replace(/-/g, "/")
        )
      }
      if (slaTimeStamp && receiveTime) {
        let s2 = new Date(receiveTime)
        var ms = Math.round(
          (s2.getTime() - slaTimeStamp.getTime()) / 1000 / 60 / 60
        )
        if (ms <= 0) {
          hintColor = "#00b78d"
        }
      }
      return hintColor
    },
    handleClickTab() {},
    handleCloseExpre() {
      this.expreVisible = false
    },
    async handleShowExpre(detail, row) {
      this.expreVisible = true
      detail.appNo = row.appNo
      detail.appId = row.appId
      if (row.trackingNumber) {
        detail.trackingNumber = row.trackingNumber
      }
      this.expreDetail = detail
    },
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        this.shopListClone = this._.clone(res.rows)
        this.$nextTick(() => {
          this.scrollMenu = document.querySelector(".table-menu")
          this.objectHeight = this.scrollMenu.offsetTop
          window.addEventListener(
            "scroll",
            this.throttle(this.handleScroll, 100)
          )
        })
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    handleChangeStatus() {
      this.form.orderStatus = []
      if (this.isCheckStatus) {
        this.dictData["order_status"].map((record) => {
          this.form.orderStatus.push(record.value)
        })
      }
    },
    getShip() {
      getShipMethod().then((res) => {
        this.shipList = res.rows
      })
    },
    getUserList() {
      listSubAccount({}).then((res) => {
        res.rows.unshift({
          userName: this.user.name,
          nickName: this.user.nickName ? this.user.nickName : this.user.name,
        })
        this.userList = res.rows
      })
    },
    handleChangeUser() {
      this.form.operNos = []
      let shopList = this._.clone(this.shopListClone)
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNos.push(record.userName)
        })
        this.shopList = shopList
      } else {
        this.shopList = shopList.filter((shop) => {
          for (let record of this.form.operNos) {
            if (record == shop.operNo) {
              return true
            }
          }
          return false
        })
      }
      this.form.shopId = []
    },

    getProducingDay(date) {
      return (
        Math.floor(((new Date() - new Date(date)) / 1000 / 60 / 60 / 24) * 10) /
        10
      )
    },
    handleAppNosBlur() {
      this.form.appNos = this.appNos.replace(/\n/g, ",")
      this.showAppNosTextarea = false
    },
    handleShowAppsNos() {
      this.appNos = this.form.appNos.replace(/,/g, "\n")
      this.showAppNosTextarea = true
    },
    handleAppNosBlurDel() {
      this.form.appNoDels = this.appNoDels.replace(/\n/g, ",")
      this.showAppNosTextareaDel = false
    },
    handleShowAppsNosDel() {
      this.appNoDels = this.form.appNoDels.replace(/,/g, "\n")
      this.showAppNosTextareaDel = true
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNos.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.form.operNos.includes(record.userName)) {
            for (let item of record.shops) {
              if (item.shopId == shop.shopId) {
                return true
              }
            }
          }
        }
        return false
      })

      this.form.shopId = []
      if (this.form.operNos.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
    },
    // 搜索
    getData() {
      this.setCache()
      let params = Object.assign({}, this.form)

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD")
      }

      if (this.form.payTime && this.form.payTime.length > 0) {
        params["payTimeBegin"] = dayjs(this.form.payTime[0]).format(
          "YYYY-MM-DD"
        )
        params["payTimeEnd"] = dayjs(this.form.payTime[1]).format("YYYY-MM-DD")
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        )
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      if (this.form.orderTime && this.form.orderTime.length > 0) {
        params["orderTimeBegin"] = dayjs(this.form.orderTime[0]).format(
          "YYYY-MM-DD"
        )
        params["orderTimeEnd"] = dayjs(this.form.orderTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      params.shopIds = params.shopId.join(",")
      params.orderStatus = params.orderStatus.join(",")
      params.operNos = params.operNos.join(",")
      params.appNos = params.appNos.replace("，", ",")
      params.orderRemarkType = params.orderRemarkType.join(",")
      params.orderRemarkColor = params.orderRemarkColor.join(",")
      // params.platNo = params.platNo.join(",")

      if (params.shopIds == "" && this.isCheckShop) {
        let shopId = []
        for (let record of this.shopList) {
          shopId.push(record.shopId)
        }
        params.shopIds = shopId.join(",")
      }
      if (!params.shopIds && params.operNos.length > 0) {
        params.shopIds = ""
      }
      if (this.user.userType == "00") {
        params.from = "02"
        delete params["shopIds"]
      }

      delete params["operNos"]

      if (this.activeName == "notpay") {
        params.orderStatus = "01"
      }

      if (this.activeName == "pay") {
        params.orderStatus = "02"
      }

      if (this.activeName == "produce") {
        params.orderStatus = "03"
      }
      if (this.activeName == "producing") {
        params.orderStatus = "04"
        params["beginTime"] = undefined
        params["endTime"] = undefined
      }
      if (this.activeName == "overdue") {
        params.orderStatus = "04"
        let curDate = new Date()
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)
        params["beginTime"] = undefined
        params["endTime"] = undefined
        params["payTimeEnd"] = this.parseTime(
          preDate,
          "{y}-{m}-{d} {h}:{i}:{s}"
        )
      }

      if (this.activeName == "other") {
        params.orderStatus = "03,04,05,06,07,09"
      }

      delete params["createTime"]
      delete params["payTime"]
      delete params["sendTime"]
      delete params["shopId"]
      delete params["orderTime"]
      this.startLoading()

      orderList(params)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("获取订单列表失败")
          } else {
            this.total = res.total
            for (let record of res.rows) {
              for (let sku of record.skuList) {
                record.manufacturer = sku.manufacturer
                record.slaTimeStamp = sku.slaTimeStamp
                record.promisedShippingTime = sku.promisedShippingTime
                record.receiveTime = sku.receiveTime
                if (record.platNo == "05" || record.platNo == "03") {
                  record.amazonOrderStatus = sku.amazonOrderStatus
                }
                record.shippingProviderType = sku.shippingProviderType
                record.shippingProvider = sku.shippingProvider
                record.trackingCode = sku.trackingCode
                record.trackingNumber = sku.trackingCode

                record.hintColor = this.getHourColor(
                  sku.slaTimeStamp,
                  sku.receiveTime
                )
                record.manufacturer = sku.manufacturer
                record.slaTimeStamp = sku.slaTimeStamp
                record.promisedShippingTime = sku.promisedShippingTime
                record.receiveTime = sku.receiveTime
                record.amazonOrderStatus = sku.amazonOrderStatus
                record.payMethod = sku.payMethod
                record.shippingProviderType = sku.shippingProviderType
                record.shippingMethod = sku.shippingMethod
                record.shippingProvider = sku.shippingProvider
                record.trackingCode = sku.trackingCode
                record.trackingNumber = sku.trackingCode
                record.remarkDict = sku.product ? sku.product.remarkDict : ""

                break
              }
            }
            this.tableData = res.rows

            res.rows.map((record) => {
              record.expand = false
            })
          }
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleSelectShip(row) {
      this.currentOrder = row
      this.showShip = true
    },
    // 重置
    reset() {
      this.form = {
        platNo: "", // 平台渠道
        amazonSite: "", // 来源国家
        productType: "", // 产品类型
        matchType: "", // 匹配类型
        orderSource: "", // 订单来源
        createTime: [], // 创建时间
        payTime: [], // 支付时间
        sendTime: [], // 发货时间
        orderTime: [], // 订单时间
        shopId: [], // 店铺名称
        appNos: "", // 订单编号
        trackingNumber: "", // 物流单号
        orderStatus: [], // 订单状态
        pOperNo: "", //商家账号
        shippingMethod: "", //物流方式
        pageNum: 1,
        orderRemarkType: [],
        orderRemarkColor: [],
        operNos: [],
        pageSize: 10,
      }
    },
    handleShowSendOrderShopee(data) {
      this.currentOrder = data
      this.showSendOrderShopee = true
    },
    hideSendOrderShopee() {
      this.showSendOrderShopee = false
      this.getData()
    },
    copyText(text) {
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制成功")
      document.body.removeChild(target)
    },
    // 列表选择
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    syncOrder() {
      this.showSyncOrder = true
    },
    hideSyncOrder() {
      this.showSyncOrder = false
    },
    exchange() {
      this.showExchange = true
    },
    hideExchange() {
      this.showExchange = false
    },
    hideCancel() {
      this.showCancel = false
    },
    okEditExchange() {
      this.getData()
      this.showExchange = false
    },
    okEditCancel() {
      this.getData()
      this.showCancel = false
    },
    service() {
      this.showService = true
    },
    hideService() {
      this.showService = false
    },
    showAudit(data) {
      this.currentOrder = data
      this.showAuditOrder = true
    },
    handleShowSendOrder(data) {
      this.currentOrder = data
      this.showSendOrder = true
    },
    hideAuditOrder() {
      this.showAuditOrder = false
    },
    okEditService() {
      this.getData()
      this.showService = false
    },
    hideSendTime() {
      this.showSendTime = false
    },
    okEditSendTime() {
      this.getData()
      this.showSendTime = false
    },
    handleShowSendTime(data) {
      this.currentOrder = data
      this.showSendTime = true
      let a = 1
    },
    showOrderDetail(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
        this.orderCanEdit = false
      })
    },
    handleCommand(command) {
      if (command == "exchange") {
        this.showExchange = true
      } else if (command == "service") {
        this.showService = true
      }
    },
    // 编辑订单
    edit(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
        this.orderCanEdit = true
      })
    },
    hideEdit() {
      this.getData()
      this.showEdit = false
    },
    onUpdateFinish(appId) {
      if (appId) {
        getOrderDetail(appId).then((res) => {
          this.currentOrder = res.data
        })
      }
    },
    remark() {
      this.showRemark = true
    },
    hideRemark() {
      this.showRemark = false
    },
    showLabelDialog(row) {
      this.remarkIds = row.appId
      if (row.sOrderRemark && row.sOrderRemark.length > 0) {
        this.orderRemark = row.sOrderRemark[0]
      }
      this.showLabel = true
    },
    handleBatchLabel() {
      let ids = []
      this.multipleSelection.map((el) => {
        ids.push(el.appId)
      })
      if (ids.length == 0) {
        this.msgError("请选择订单")
        return
      }
      this.remarkIds = ids.join(",")
      this.orderRemark = {}
      this.showLabel = true
    },
    hideLabelDialog() {
      this.showLabel = false
    },
    hideShip() {
      this.showShip = false
      this.getData()
    },
    goReview() {
      const ids = []
      const orderStatusArray = []
      let shipFlag = true

      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
        orderStatusArray.push(el.orderStatus)
        if (!(el.expre && el.expre.shippingMethod)) {
          shipFlag = false
        }
      })

      if (orderStatusArray.length == 0) {
        this.$message.error("请选择订单")
        return false
      }

      for (let record of orderStatusArray) {
        if (record != "02") {
          this.$message.info("只有已付款的订单才能审核")
          return false
        }
      }
      this.currentOrder = {
        appNo: ids.join(","),
      }
      this.showAuditOrder = true
    },
    hideSendOrder() {
      this.showSendOrder = false
      this.getData()
    },
    // 复制订单
    copy(data) {
      orderToCopy(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showCopy = true
      })
    },
    hideCopy() {
      this.showCopy = false
    },
    showSale(data) {
      this.currentOrder = data
      this.showEditSale = true
    },
    hideEditSale() {
      this.showEditSale = false
    },
    okEditSale() {
      this.getData()
      this.showEditSale = false
    },
    okCopyOrder() {
      this.getData()
      this.showCopy = false
    },
    okAuditOrder() {
      this.getData()
      this.showAuditOrder = false
    },
    okLabelDialog() {
      this.getData()
      this.showLabel = false
    },
    exportOrder() {
      let params = Object.assign({}, this.form)
      params.orderStatus = params.orderStatus.join(",")
      let ids = []
      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
      })
      if (ids.length > 0) {
        params.appNos = ids.join(",")
      }

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD")
      }

      if (this.form.payTime && this.form.payTime.length > 0) {
        params["payTimeBegin"] = dayjs(this.form.payTime[0]).format(
          "YYYY-MM-DD"
        )
        params["payTimeEnd"] = dayjs(this.form.payTime[1]).format("YYYY-MM-DD")
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        )
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      if (this.form.orderTime && this.form.orderTime.length > 0) {
        params["orderTimeBegin"] = dayjs(this.form.orderTime[0]).format(
          "YYYY-MM-DD"
        )
        params["orderTimeEnd"] = dayjs(this.form.orderTime[1]).format(
          "YYYY-MM-DD"
        )
      }
      delete params["createTime"]
      delete params["payTime"]
      delete params["sendTime"]
      delete params["pageNum"]
      delete params["pageSize"]
      delete params["orderTime"]
      downLoadExcel(
        `/server/order/export?${qs.stringify(params)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    // 取消订单
    cancelOrderFn(data) {
      this.$confirm("请确认是否取消订单？", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        cancelOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("取消失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "取消成功!",
            })
          }
        })
      })
    },
    async handleQuickOrder(row) {
      try {
        this.$confirm("请确认是否加急订单？", "加急订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.startLoading()
          let result = await createShip({ appId: row.appId })
          this.$message({
            type: "success",
            message: result.msg,
          })
          this.getData()
          this.endLoading()
        })
      } catch (error) {
        this.endLoading()
      }
    },
    async handleQuickOrderNew(row) {
      try {
        this.$confirm("请确认是否加急订单？", "加急订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.startLoading()
          let result = await createBatchShip({ appId: row.appId })
          if (result.code == 200) {
            this.$message({
              type: "success",
              message: result.msg,
            })
            this.getData()
            this.endLoading()
          }
        })
      } catch (error) {
        this.endLoading()
      }
    },
    async handleQuickOrderBatch(row) {
      try {
        const ids = []

        this.multipleSelection.map((el) => {
          ids.push(el.appId)
        })

        if (ids.length == 0) {
          this.$message.error("请选择订单")
          return false
        }

        this.$confirm("请确认是否批量加急订单？", "加急订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.startLoading()
          let result = await createShip({ appId: ids.join(",") })
          this.$message({
            type: "success",
            message: result.msg,
          })
          this.getData()
          this.endLoading()
        })
      } catch (error) {
        this.endLoading()
      }
    },
    async handleQuickOrderBatchNew(row) {
      try {
        const ids = []

        this.multipleSelection.map((el) => {
          ids.push(el.appId)
        })

        if (ids.length == 0) {
          this.$message.error("请选择订单")
          return false
        }

        this.$confirm("请确认是否批量加急订单？", "加急订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.startLoading()
          let result = await createBatchShip({ appId: ids.join(",") })
          if (result.code == 200) {
            this.$message({
              type: "success",
              message: result.msg,
            })
            this.getData()
            this.endLoading()
          }
        })
      } catch (error) {
        this.endLoading()
      }
    },
    async handleRefund(row) {
      try {
        this.$confirm("请确认是否取消订单？", "取消订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.currentOrder = row
          this.showCancel = true
        })
      } catch (error) {
        this.endLoading()
      }
    },
    // 恢复订单
    renewOrder(data) {
      this.$confirm("请确认是否恢复订单？", "恢复订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        recoveryOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("恢复失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "恢复成功!",
            })
          }
        })
      })
    },
    handleOpenDetail(row) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: row.pId, designId: row.designId },
      })
      window.open(routeUrl.href, "_blank")
    },
    goPay() {
      //判断是否有支付权限

      const ids = []
      const orderStatusArray = []
      let manufacturer = []
      let shipFlag = true

      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
        manufacturer.push(el.manufacturer)
        orderStatusArray.push(el.orderStatus)
        if (!el.expreList || el.expreList.length == 0) {
          shipFlag = false
        } else {
          for (let record of el.expreList) {
            if (!record.shippingMethod) {
              shipFlag = false
            }
          }
        }
      })

      for (let record of this.multipleSelection) {
        if (
          (record.platNo == "03" || record.platNo == "05") &&
          !record.attachId
        ) {
          this.$message.error("请上传面单再进行付款")
          return false
        }
      }

      for (let record of this.multipleSelection) {
        if (
          record.addr &&
          (!record.addr.state || !record.addr.mobile || !record.addr.receName)
        ) {
          this.$message.error("收件地址没有填写正确，请填写再付款")
          return false
        }
      }

      if (orderStatusArray.length == 0) {
        this.$message.error("请选择订单")
        return false
      }
      if (this._.union(manufacturer).length > 1) {
        this.$message.info("不同生产厂商订单不可一起付款哦")
        return
      }

      for (let record of orderStatusArray) {
        if (record != "01") {
          this.$message.info("待付款的订单才能批量支付货款")
          return false
        }
      }

      if (!shipFlag) {
        this.$message.error("没有选择物流方式，不能批量支付货款")
        return false
      }

      this.$router.push({
        path: "/order/myOrder/getPay",
        query: { id: ids.join(",") },
      })
    },
    goRelate(data) {
      this.$router.push({
        path: "/order/order_aid/toMatchOrder",
        query: {
          appNo: data.appNo,
        },
      })
    },
    handleShowUploadLabel(row) {
      this.importForm.appId = row.appId
      this.$refs.inputer ? (this.$refs.inputer.value = "") : ""
      this.showUploadLabel = true
    },
    async getLabel(row) {
      try {
        if (!row.sShopAuth) {
          this.msgError("店铺未授权，请人工上传")
          return
        }
        this.startLoading()

        if (row.platNo == "03") {
          await getTb({ appId: row.appId })
        } else {
          await downloadDoc({ appId: row.appId })
        }
        this.getData()
        this.msgSuccess("获取面单成功")
        this.endLoading()
        // window.open(result.msg, "_blank")
      } catch (error) {
        this.endLoading()
      }
    },
    uploadFn() {
      let inputDOM = this.$refs.inputer
      let file = inputDOM.files

      this.importForm.file = file
    },
    handleUploadLabel() {
      this.$refs["importForm"].validate((valid) => {
        if (valid) {
          this.startLoading()
          let formData = new FormData()

          formData.append("file", this.importForm.file[0])
          formData.append("appId", this.importForm.appId)

          uploadTb(formData)
            .then((res) => {
              if (res.code !== 200) {
                this.$message.error("上传失败")
              } else {
                this.$message.success("上传成功")
                this.showModal = false
                // this.successOrder = res.rows
                this.showUploadLabel = false
                this.getData()
              }
              this.endLoading()
            })
            .catch(() => {
              this.endLoading()
            })
        }
      })
    },
    handleShowDetail(record) {
      this.productList = record.shipList
      this.detailVisible = true
    },
    handleCloseDetail() {
      this.detailVisible = false
    },
    handleOpenProduct(row) {
      let routeUrl = ""
      if (row.productType == "01") {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { designId: row.designId },
        })
      } else {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { pId: row.pId },
        })
      }

      window.open(routeUrl.href, "_blank")
    },
    caculateProduct(data) {
      let count = 0
      for (let record of data) {
        count += Number(record.num)
      }
      return count
    },
    handleExpand(row) {
      row.expand = !row.expand
      row.skuList = this._.clone(row.skuList)
    },
    handleCheckAll() {
      this.form.shopId = []
      for (let record of this.shopList) {
        this.form.shopId.push(record.shopId)
      }
    },
    throttle(fn, wait) {
      var pre = Date.now()
      return function() {
        var context = this
        var args = arguments
        var now = Date.now()
        if (now - pre >= wait) {
          fn.apply(context, args)
          pre = Date.now()
        }
      }
    },
    handleScroll() {
      var menu = this.scrollMenu
      //获取页面的滚动距离
      var scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop
      //滚动到一定位置 div固定到顶部 js实现吸顶
      if (this.objectHeight < scrollHeight) {
        menu.style.position = "fixed"
        menu.style.top = 0
        menu.style.width = "calc(100% - 290px)"
        menu.style.padding = "8px 0"
      } else {
        menu.style.position = "relative"
        menu.style.width = "100%"
        menu.style.padding = "0"
      }
    },
  },
}
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
  min-height: 42px;
}

.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body /deep/ .expanded {
  background: #f5f7fa;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  width: 111px;
  height: 111px;
  margin-bottom: 10px;
  position: relative;
}

.table-info .left .mini-img {
  width: 109px;
  height: 109px;
  border: 1px solid #dddddd;
}

.table-info .right {
  font-size: 12px;
  width: 200px;
  padding: 0 0 4px 0;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.operate .link {
  font-size: 12px;
  color: #4934b2;
  cursor: pointer;
}

.table /deep/.el-table_1_column_1 {
  width: 0px !important;
  height: 0px !important;
}

.table /deep/.el-table_1_column_1 .cell {
  visibility: hidden !important;
  cursor: not-allowed !important;
}

.table /deep/.el-table__expanded-cell[class*="cell"] {
  padding: 8px 16px;
}

.table /deep/ .el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: hidden;
}
.custom-order /deep/ .el-select {
  width: 100%;
}

.custom-order /deep/ .el-date-editor {
  width: 100%;
}
.product-type {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.product-tag {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: #ff9000;
  background-color: #ff9000;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.design_flag {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #aaaaaa;
  padding: 0 4px;
  color: #ffffff;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}
.custom-order ::v-deep .el-tabs__item.is-active {
  background: #ffffff;
}
.background-color-item {
  width: 24px;
  height: 24px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  cursor: pointer;
  list-style: none;
  box-sizing: border-box;
  margin: 4px 8px 0 0;
  float: left;
}
.background-color-text {
  height: 24px;
  float: left;
}

.textareaBox {
  display: block;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.btnIconDown {
  position: absolute;
  left: 5px;
  top: -4px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  padding: 4px 10px;
  z-index: 5;
}
.batch_txt {
  font-size: 13px;
  transform: initial !important;
  color: #3d2c96;
}
.batch_inputbox ::v-deep .el-input__inner {
  padding: 0 50px;
}
</style>
